module.exports = __webpack_public_path__ + "img/dataReport_4.c9536c77.png";